import m from "../../es2015/lang/de_CH";
window.am4lang_de_CH = m;


//////////////////
// WEBPACK FOOTER
// ./lang/de_CH.js
// module id = null
// module chunks = 